
// /////////////////////////////////////////////////////////////
// Google Firebase のログインセッションチェック
// /////////////////////////////////////////////////////////////
import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../firebase/AuthProvider";
import LoadingView from "../components/LoadingView";

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 認証状態の確認中は画面全体のローディングを表示
  if (loading) return <LoadingView message="認証情報を確認しています..." height="100vh" />;
  // 未認証時はアクセスしようとした場所を state に保持してログインへ送る
  // (ログイン後に元のページへ戻すため)
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  return <>{children}</>;
};

export default PrivateRoute;
